
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'

import SellerMenuButtons from '@/components/Seller/Menu/SellerMenuButtons.vue'
import { State, Action } from 'vuex-class'
import TermsAndConditionsModal from '@/components/shared/TermsAndConditionsModal.vue'
import { TermsAndConditionsBlock } from '@/interfaces/terms-and-conditions.interface'

@Component({
  components: {
    SellerMenuButtons,
    SellerHeader,
    TermsAndConditionsModal,
  },
})
export default class SellerMenu extends Vue {
  @State(({ userState }) => userState.userInfo.fullname) fullname!: string
  @Action setUserName!: Function
  @Action resetEventTermsContext!: Function

  eventName: string = ''

  get terms(): TermsAndConditionsBlock | null {
    return this.$store.state.termsState?.terms || null
  }

  get termsModalOpen(): boolean {
    return !!this.$store.state.termsState?.termsModalOpen
  }

  get termsLoading(): boolean {
    return !!this.$store.state.termsState?.termsLoading
  }

  get headerText(): string {
    if (this.eventName === '') {
    return 'Cargando...'
  }
    return this.eventName || 'Hola ' + this.fullname.split(' ')[0] + '!'
  }

  updateHeaderText(name: string): void {
    this.eventName = name
  }

  logout(): void {
    this.$toast.success(`Hasta luego ${this.fullname}`)
    localStorage.clear()
    localStorage.removeItem('jwt')
    this.$router.push('/login')
  }

  mounted(): void {
    this.setUserName(localStorage.getItem('name'))
  }

  beforeDestroy(): void {
    // Al salir del evento (volver a /seller o navegar a otro lado), resetear estado TyC local
    this.resetEventTermsContext()
  }

  onAccept() {
    this.$store.dispatch('acceptTerms')
  }

  onSkip() {
    this.$store.dispatch('skipTerms')
  }

  onModalInput(open: boolean) {
    if (open === false) {
      this.$store.dispatch('skipTerms')
    }
  }
}
